import React, { Component } from 'react';
import Style from 'components/Header/headerStyles.module.css';
import { withRouter } from 'react-router-dom';
import logo from 'assets/logo_white.png';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.refreshHandler = this.refreshHandler.bind(this);
        this.handleGoToHome = this.handleGoToHome.bind(this);
        this.handleTopicSelectorClick = this.handleTopicSelectorClick.bind(this);
    }

    refreshHandler() {
        window.location.reload();
    }

    handleGoToHome() {
        const { history } = this.props;
        history.goBack();
    }

    handleTopicSelectorClick() {
        // Navigate to topic selector screen
        this.props.history.push('/topic-selector');
    }

    render() {
        const { title, refresh = false, back = false, backHandler = false, showTopicSelector = false, showRightButton = false, rightButtonText, onRightButtonClick, showRightText = false, rightText } = this.props;

        return (
            <div className={Style.HeaderLayout}>
                <div
                    className={`container ${Style.HeaderContainer}`}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '6px' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', flex: '1 1 auto', minWidth: 0 }}>
                        {back && backHandler ? (
                            <div
                                className={Style.HeaderIcons}
                                onClick={backHandler}
                                style={{ display: 'flex', alignItems: 'center' }}
                            >
                                <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 512 512"
                                    height="1.5em"
                                    width="1.5em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M401.4 224h-214l83-79.4c11.9-12.5 11.9-32.7 0-45.2s-31.2-12.5-43.2 0L89 233.4c-6 5.8-9 13.7-9 22.4v.4c0 8.7 3 16.6 9 22.4l138.1 134c12 12.5 31.3 12.5 43.2 0 11.9-12.5 11.9-32.7 0-45.2l-83-79.4h214c16.9 0 30.6-14.3 30.6-32 .1-18-13.6-32-30.5-32z"></path>
                                </svg>
                                <p
                                    className={Style.HeaderTitle}
                                    style={{ margin: '0', fontSize: '12px', paddingLeft: '4px' }}
                                >
                                    {title}
                                </p>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    className={Style.HeaderLogo}
                                    src={logo}
                                    alt="HeaderLogo"
                                    onClick={this.handleGoToHome}
                                    style={{ cursor: 'pointer', height: '24px' }}
                                />
                                <p
                                    className={Style.HeaderTitle}
                                    style={{ margin: '0', fontSize: '12px', paddingLeft: '4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '45vw' }}
                                >
                                    {title}
                                </p>
                            </div>
                        )}
                        {refresh && (
                            <div
                                className={Style.HeaderIcons}
                                onClick={this.refreshHandler}
                                style={{ marginLeft: '8px', display: 'flex', alignItems: 'center' }}
                            >
                                <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 512 512"
                                    height="1.5em"
                                    width="1.5em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M256 388c-72.597 0-132-59.405-132-132 0-72.601 59.403-132 132-132 36.3 0 69.299 15.4 92.406 39.601L278 234h154V80l-51.698 51.702C348.406 99.798 304.406 80 256 80c-96.797 0-176 79.203-176 176s78.094 176 176 176c81.045 0 148.287-54.134 169.401-128H378.85c-18.745 49.561-67.138 84-122.85 84z"></path>
                                </svg>
                            </div>
                        )}
                    </div>

                    {/* Right-side plain text, button, or Topic Selector */}
                    {showRightText ? (
                        <div style={{ display: 'flex', alignItems: 'center', flex: '0 1 auto', minWidth: 0 }}>
                            <span className={Style.RightText}>
                                {rightText}
                            </span>
                        </div>
                    ) : showRightButton ? (
                        <div>
                            <span
                                className={Style.button}
                                style={{
                                    padding: '3px',
                                    backgroundColor: '#fff',
                                    cursor: 'pointer',
                                    fontSize: '10px',
                                }}
                                onClick={onRightButtonClick}
                            >
                                {rightButtonText}
                            </span>
                        </div>
                    ) : (
                        showTopicSelector && (
                            <div>
                                <span
                                    className={Style.button}
                                    style={{
                                        padding: '3px',
                                        backgroundColor: '#fff',
                                        cursor: 'pointer',
                                        fontSize: '10px',
                                    }}
                                    onClick={this.handleTopicSelectorClick}
                                >
                                    Select Topics
                                </span>
                            </div>
                        )
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(Header);
